import {
  Box,
  Card,
  CardBody,
  Divider,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  useMediaQuery,
  Button,
  SimpleGrid,
  Select,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
} from "@chakra-ui/react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
// import { ChevronLeftIcon } from "@chakra-ui/icons";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import React, { useState, useContext, useEffect } from "react";
import Colors from "../../assets/colors/Colors";
import smsImg from "../../assets/images/chat_10419161.png";
import emailImg from "../../assets/images/chat_7246831.png";
// import PosFormButton from "../button/PosFormButton";
import onboardingFlowSecondstep from "../../assets/images/onboardingFlowSecondstep.png";
import contactUsIcon from "../../assets/images/contactUsIcon.png";
// import PosInput from "../input/PosInput";

import * as Yup from "yup";
import * as Constants from "../../constants/Constants";
import { useFormik } from "formik";
import {
  getAllCountriesState,
  getStateListForSelectedCountry,
  updateUserTwilioPhoneNumberStatus,
} from "./marketingOnbordingFormServices";
import { PosErrorHook } from "../../hooks";
import {
  AppContext,
  PosBreadCrumb,
  PosCountryStateDropDown,
  PosFormButton,
  PosInput,
  PosLable,
  PosSwitchButton,
  PosTab,
  PosTable,
  PosTostMessage,
} from "../index";
import rightIconForMarketing from "../../assets/images/rightIconForMarketing.png";
import pendingApproval from "../../assets/images/pendingApproval.png";
import pendingApprovalBackground from "../../assets/images/pendingApprovalBackground.png";
import processPendingIcon from "../../assets/images/processPendingIcon.png";

const MarketingOnbordingForm = (props) => {
  const { error } = PosErrorHook();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const { addToast } = PosTostMessage();
  const myContext = useContext(AppContext);
  const [firstStep, setFirstStep] = useState(
    props.fillForm !== undefined &&
      props.fillForm !== null &&
      props.fillForm !== ""
      ? props.fillForm
      : false
  );
  const [secondStep, setSecondStep] = useState(false);
  const [finalStep, setFinalStep] = useState(false);
  const [statusPendingList, setStatusPendingList] = useState(
    props.pendingList !== undefined &&
      props.pendingList !== null &&
      props.pendingList !== ""
      ? props.pendingList
      : false
  );
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [stateError, setStateError] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [previousSelectedCountry, setPreviousSelectedCountry] = useState("");
  const [stateAvailable, setStatesAvailability] = useState(1);
  const [allTouchedField, setAllTouchedField] = useState(false);
  const marketingTypes = [
    {
      id: 1,
      type: "Email Marketing",
      typeHeading: "Send Email to your customers          ",
      imageName: smsImg,
      description1:
        "Select and Edit Existing Templates to send Emails to customers",
      description2: "Send targeted coupons via Email",
    },
    {
      id: 2,
      type: "Text Message Marketing",
      typeHeading: "Send SMS to your customers ",
      imageName: emailImg,
      description1: "Send text messages to your existing customers",
      description2: "Send targeted coupons via sms",
    },
  ];
  useEffect(() => {
    setFirstStep(
      props.fillForm !== undefined &&
        props.fillForm !== null &&
        props.fillForm !== ""
        ? props.fillForm
        : false
    );
    setStatusPendingList(
      props.pendingList !== undefined &&
        props.pendingList !== null &&
        props.pendingList !== ""
        ? props.pendingList
        : false
    );
  }, [props.fillForm, props.pendingList]);
  // props.pendingApprovalList;
  const pendingStatusList = [props.pendingApprovalList];
  // [
  //   {
  //     id: 1,
  //     company_name: "Register My Brand",
  //     tenant_name: "Company Name",
  //     phone_number: "Phone Number",
  //     email: "Email",
  //     status: "Status",
  //   },
  // ];
  const [isMobile] = useMediaQuery("(max-width: 992px)");
  const [isScreenSize480] = useMediaQuery("(max-width: 480px)");

  const formik = useFormik({
    initialValues: {
      legalCompanyName: "",
      dbaOrBrandName: "",
      phone: "",
      email: "",
      address: "",
      city: "",
      selectedCountry: "",
      selectedState: "",
      // country: "",/
      zipcode: "",
      legalForm: "",
      taxNumber: "",
      website: "",
    },
    validationSchema: Yup.object({
      legalCompanyName: Yup.string()
        .required(Constants.LEGAL_COMPANY_NAME_REQUIRED)
        .max(191, Constants.LEGAL_COMPANY_NAME_LENGTH_GREATE_THEN_191),
      dbaOrBrandName: Yup.string()
        .required(Constants.DBA_OR_BRAND_NAME_REQUIRED)
        .max(191, Constants.DBA_OR_BRAND_NAME_LENGTH_GREATE_THEN_191),
      phone: Yup.number()
        .required(Constants.PHONE_FOR_MARKETING_ONBOARDING_REQUIRED)
        .typeError(Constants.PHONE_FOR_MARKETING_ONBOARDING_NOT_VALID)
        .integer(Constants.PHONE_FOR_MARKETING_ONBOARDING_NOT_VALID)
        .min(100, Constants.PHONE_FOR_MARKETING_ONBOARDING_MIN_VALUE)
        .max(9999999999, Constants.PHONE_FOR_MARKETING_ONBOARDING_MAX_VALUE),
      email: Yup.string()
        .required(Constants.EMAIL_FOR_MARKETING_ONBOARDING_REQUIRED)
        .matches(
          Constants.EMAIL_REGEX,
          Constants.EMAIL_INVALID_FOR_MARKETING_ONBOARDING
        )
        .email(Constants.EMAIL_INVALID_FOR_MARKETING_ONBOARDING)
        .max(
          191,
          Constants.EMAIL_FOR_MARKETING_ONBOARDING_LENGTH_GREATE_THEN_191
        ),
      address: Yup.string()
        .required(Constants.ADDRESS_REQUIRED)
        .max(191, Constants.ADDRESS_LENGTH_GREATE_THEN_191),
      city: Yup.string()
        .trim()
        .required(Constants.CITY_REQUIRED)
        .max(191, Constants.CITY_LENGTH_GREATE_THEN_191),
      selectedCountry: Yup.string().required(
        Constants.CUSTOMER_PLEASE_SELECT_A_COUNTRY
      ),
      selectedState: Yup.string().required(
        Constants.CUSTOMER_PLEASE_SELECT_A_STATE
      ),
      zipcode: Yup.number()
        .required(Constants.LOCATION_ZIP_REQUIRED)
        .integer(Constants.LOCATION_ZIP_VALID)
        .typeError(Constants.LOCATION_ZIP_VALID)
        .min(9, Constants.LOCATION_ZIP_MUST_BE_2_DIGITS)
        .max(9999999999, Constants.LOCATION_ZIP_MUST_BE_10_DIGITS),
      legalForm: Yup.string()
        .required(Constants.LEGAL_FORM_REQUIRED)
        .max(191, Constants.LEGAL_FORM_LENGTH_GREATE_THEN_191),
      taxNumber: Yup.string()
        .required(Constants.TAX_NUMBER_REQUIRED)
        .max(191, Constants.TAX_NUMBER_LENGTH_GREATE_THEN_191),
      website: Yup.string()
        // .required(Constants.WEBHOOK_URL_REQUIRED)
        .matches(Constants.WEBHOOK_URL_PATTERN, Constants.WEBSITE_INVALID),
    }),
    onSubmit: async (values) => {},
  });

  const getCountryStates = async () => {
    try {
      getAllCountriesState()
        .then((response) => {
          if (
            undefined !== response.data.flag &&
            null !== response.data.flag &&
            response.data.flag == true
          ) {
            const arrayCountries = Object.keys(
              response.data.data.countries
            ).map((key) => ({
              label: response.data.data.countries[key],
              value: key,
            }));
            setCountries(arrayCountries);
            myContext.handleLoading(false);
          } else {
            let actionData = response;
            error({ actionData });
            myContext.handleLoading(false);
          }
        })
        .catch((err) => {
          let actionData = err;
          error({ actionData });
          myContext.handleLoading(false);
        });
    } catch (error) {
      myContext.handleLoading(false);
    }
  };

  const handleSelectedCountry = (value) => {
    try {
      setSelectedCountry(value);
      setStates([]);
      setSelectedState(null);
      setStateError("");
      formik.setFieldValue("selectedState", null);

      myContext.handleLoading(true);
      getStateListForSelectedCountry(value)
        .then((response) => {
          if (
            undefined !== response.data.flag &&
            null !== response.data.flag &&
            response.data.flag == true
          ) {
            const statesData = response.data.data.states;
            const arrayStates = Object.keys(statesData).map((key) => ({
              label: statesData[key],
              value: key,
            }));
            setStates(arrayStates);
            const customerState = response?.data?.data?.customerData?.state;
            if (
              customerState &&
              customerState !== "N.A" &&
              customerState !== null &&
              statesData[customerState]
            ) {
              if (
                response?.data?.data?.customerData?.country !==
                previousSelectedCountry
              ) {
                setSelectedState(customerState);
              } else if (
                response?.data?.data?.customerData?.country ===
                previousSelectedCountry
              ) {
                setSelectedState("");
              }
              setPreviousSelectedCountry(
                response?.data?.data?.customerData?.country
              );
              formik.setFieldValue("selectedState", customerState);
              setStatesAvailability(0);
            } else {
              // setSelectedState("N.A");
              // formikCustomer.setFieldValue("selectedState", "N.A");
              setStatesAvailability(1);
            }
          } else {
            setStates([]);
            setSelectedState("N.A");
            formik.setFieldValue("selectedState", "N.A");
            setStatesAvailability(1);
          }
          myContext.handleLoading(false);
        })
        .catch((err) => {
          setStates([]);
          setSelectedState("N.A");
          formik.setFieldValue("selectedState", "N.A");
          setStatesAvailability(1);
          let actionData = err;
          error({ actionData });
          myContext.handleLoading(false);
        });
    } catch (error) {
      setStates([]);
      setSelectedState("N.A");
      formik.setFieldValue("selectedState", "N.A");
      setStatesAvailability(1);
      let actionData = error;
      error({ actionData });
      myContext.handleLoading(false);
    }
  };

  const handleSelectedState = (value) => {
    setSelectedState(value);
    if (value == "N.A") {
      setStatesAvailability(1);
    } else {
      setStatesAvailability(0);
    }
  };

  const onSubmitClick = () => {
    myContext.handleLoading(true);
    if (
      formik.values !== undefined &&
      formik.values !== null &&
      formik.values !== ""
    ) {
      let payload = {
        ...formik.values,
        // country: selectedCountry,
        // state: selectedState,
      };
      axios
        .post(process.env.REACT_APP_MARKETING_ONBOARDING_API_ROUTE, payload, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // addToast({
          //   alertStatus: Constants.TOAST_TYPE_SUCESS,
          //   alertTitle: Constants.MARKETING_ONBOARDING_MODULE_NAME,
          //   alertDescription: Constants.MARKETING_ONBOARDING_SUCCESS_MESSAGE,
          // });
          // handleUpdateUserTwilioPhoneNumberStatus();
          myContext.handleLoading(false);
          handleUpdateUserTwilioPhoneNumberStatus();
          // setStatusPendingList(true);
          // setFinalStep(false);
        })
        .catch((error) => {
          addToast({
            alertStatus: Constants.TOAST_TYPE_ERROR,
            alertTitle: Constants.MARKETING_ONBOARDING_MODULE_NAME,
            alertDescription: Constants.MARKETING_ONBOARDING_ERROR_MESSAGE,
          });
          myContext.handleLoading(false);
        });
    }
  };

  const handleUpdateUserTwilioPhoneNumberStatus = () => {
    const payload = {
      number: formik.values.phone,
    };
    try {
      updateUserTwilioPhoneNumberStatus(payload)
        .then((response) => {
          if (
            undefined !== response.data.flag &&
            null !== response.data.flag &&
            response.data.flag == true
          ) {
            onOpen();
            myContext.handleLoading(false);
          } else {
            let actionData = response;
            error({ actionData });
            myContext.handleLoading(false);
          }
        })
        .catch((err) => {
          let actionData = err;
          error({ actionData });
          myContext.handleLoading(false);
        });
    } catch (error) {
      myContext.handleLoading(false);
    }
  };
  const handleBackToHome = () => {
    onClose();
    navigate(Constants.DASHBOARD_PATH);
  };
  return (
    <Box>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        isCentered
        onOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader></ModalHeader>
          <ModalCloseButton
            onClick={handleBackToHome}
            size="sm"
            p={2}
            borderColor={Colors.posTextAreaBorder}
            color={Colors.posTextInfo}
            borderRadius="full"
          />
          <ModalBody p={4}>
            <Flex direction="column" align="center" justify="center" gap={4}>
              <Box position="relative" height="74px" width="98px">
                {/* Background image */}
                <Image
                  src={pendingApprovalBackground}
                  alt="Pending Approval Background"
                  width="100%"
                />
                <Box
                  position="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%, -50%)"
                  zIndex="1"
                >
                  <Image src={pendingApproval} alt="Pending Approval" />
                </Box>
              </Box>
              <Flex
                direction="column"
                align="center"
                justify="center"
                maxW="362px"
                gap={4}
              >
                <Text
                  fontSize="15px"
                  fontWeight="500"
                  lineHeight="100%"
                  letterSpacing="-1.5%"
                  color={Colors.posTextInfo}
                >
                  Pending Approval
                </Text>
                <Text
                  fontSize="12px"
                  fontWeight="400"
                  // lineHeight="100%"
                  lineHeight="1.5"
                  letterSpacing="-1.5%"
                  color={Colors.posTextInfo}
                  textAlign="center"
                >
                  We're currently reviewing your information to activate your
                  number for Text Message Marketing. This process typically
                  takes up to 2 weeks.
                </Text>
                <Text
                  fontSize="12px"
                  fontWeight="400"
                  lineHeight="100%"
                  letterSpacing="-1.5%"
                  color={Colors.posTextInfo}
                >
                  We'll notify you as soon as your phone number is activated.
                </Text>
              </Flex>
              <Button w ="137px" h="38px" bg={"#5881FE0D"} borderColor={"#5881FE0D"} borderRadius="5px" borderWidth="0.3px" color={Colors.posTextInfo} fontWeight="500" fontSize="12px" variant="marketingOutline" onClick={handleBackToHome} mb={10}>
                Back to Home
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
      {firstStep && (
        <Box
        // mt={{ base: "2rem", md: "2rem" }}
        // bg={Colors.posPageDataBackground}
        >
          <Box
            m={{ base: "2rem", md: "0" }}
            mb={0}
            // pt={{ base: "4.44rem", md: "4.44rem" }}
            textAlign={"center"}
          >
            <Heading
              fontSize={{base:"1rem", md:"1.50rem"}}
              fontStyle={"normal"}
              fontWeight={"600"}
              lineHeight={"normal"}
              letterSpacing={"-0.02rem"}
              color={Colors.posTextInfo}
            >
              Setup Your Marketing Campaign
            </Heading>
            <Text
              fontSize={{base:"0.75rem", md:"0.94rem"}}
              fontStyle={"normal"}
              fontWeight={"500"}
              lineHeight={"normal"}
              letterSpacing={"-0.01rem"}
              color={Colors.taxCreateExemptEbt}
            >
              In Order to send Emails or Text Message you need to go through SMS
              Marketing Setup
            </Text>
          </Box>
          <Divider
            pt={{ base: "2rem", md: "2rem" }}
            h={"0.8px"}
            color={Colors.dividerColor}
          />

          <Flex flexDirection="column" alignItems="center">
            <Box
              display={"flex"}
              justifyContent={"center"}
              m={{ base: "2.5rem", md: "2rem" }}
            >
              <Stack
                direction={!isMobile ? "row" : "column"}
                spacing={"1.5rem"}
              >
                {marketingTypes.map((option, index) => {
                  return (
                    <Box
                      key={index}
                      maxWidth="20.75rem"
                      borderRadius="0.63rem"
                      boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
                      // _hover={{
                      //   transform: "translateY(-2px)",
                      //   transition: "transform 0.3s ease",
                      // }}
                    >
                      <Card>
                        <CardBody>
                          <Box
                            minH={"10.38rem"}
                            bg={Colors.campCardBgColor}
                            position={"relative"}
                          >
                            <Image
                              margin={"auto"}
                              position={"absolute"}
                              top={"0"}
                              left={"0"}
                              right={"0"}
                              bottom={"0"}
                              src={option.imageName}
                              alt="Octopos"
                            />
                          </Box>
                          <Box
                            // paddingX={{ base: "1rem", md: "1.5rem" }}
                            pt={{ base: "1.81rem", md: "1.81rem" }}
                            // p={"1.81rem"}
                            textAlign={"left"}
                          >
                            <Heading
                              fontSize={"1.13rem"}
                              fontStyle={"normal"}
                              fontWeight={"500"}
                              lineHeight={"normal"}
                              letterSpacing={"-0.02rem"}
                              color={Colors.posTextInfo}
                            >
                              {option.type}
                            </Heading>
                            <Text
                              fontSize={"0.94rem"}
                              fontStyle={"normal"}
                              fontWeight={"500"}
                              lineHeight={"normal"}
                              letterSpacing={"-0.01rem"}
                              color={Colors.taxCreateExemptEbt}
                              mb={"1rem"}
                            >
                              {option.typeHeading}
                            </Text>
                            <Flex>
                              <Image
                                mr={"0.5rem"}
                                height={"1.44rem"}
                                width={"1.44rem"}
                                src={rightIconForMarketing}
                                alt="rightIconForMarketing"
                              />
                              <Text
                                fontSize={"0.94rem"}
                                fontStyle={"normal"}
                                fontWeight={"400"}
                                lineHeight={"normal"}
                                letterSpacing={"-0.01rem"}
                                color={Colors.taxCreateExemptEbt}
                              >
                                {option.description1}
                              </Text>
                            </Flex>
                            <Flex mb={"4.5625rem"}>
                              <Image
                                mr={"0.5rem"}
                                height={"1.44rem"}
                                width={"1.44rem"}
                                src={rightIconForMarketing}
                                alt="rightIconForMarketing"
                              />
                              <Text
                                fontSize={"0.94rem"}
                                fontStyle={"normal"}
                                fontWeight={"400"}
                                lineHeight={"normal"}
                                letterSpacing={"-0.01rem"}
                                color={Colors.taxCreateExemptEbt}
                              >
                                {option.description2}
                              </Text>
                            </Flex>
                          </Box>
                        </CardBody>
                      </Card>
                    </Box>
                  );
                })}
              </Stack>
            </Box>
          </Flex>
          <Box pb={{ base: "4.25rem", md: "4.25rem" }} textAlign={"center"}>
            <PosFormButton
              buttonsubmit={"Setup Marketing"}
              width={!isScreenSize480 ? "22.13rem" : "11.60rem"}
              onClick={() => {
                setFirstStep(false);
                setSecondStep(true);
              }}
            />
          </Box>
        </Box>
      )}
      {secondStep && (
        <Box mx="auto" px={4}>
          <Flex direction="column" align="center" mb={8}>
            <Flex position="relative" width="100%" alignItems="center" mb={{base:4, md:10}}>
              {/* Arrow positioned absolutely on the left */}
              <Box position="absolute" left={0}>
                <ChevronLeftIcon
                  sx={{
                    color: Colors.posTextInfo,
                    fontSize: "1.50rem", // Match heading font size
                    width: "2rem", // Ensure width matches
                    height: "2rem",
                  }}
                  cursor="pointer"
                  onClick={() => {
                    setSecondStep(false);
                    setFirstStep(true);
                  }}
                />
              </Box>

              {/* Heading centered in the flex container */}
              <Heading
                as="h1"
                // size="lg"
                ml={{base:2, md:0}}
                fontSize={{base:"1rem", md:"1.50rem"}}
                fontWeight="600"
                color={Colors.posTextInfo}
                width="100%"
                textAlign="center"
              >
                Get Started with Text Message Marketing
              </Heading>
            </Flex>

            {/* Phone Image */}
            <Box
              mb={8}
              maxW="350px"
              borderRadius="md"
              overflow="hidden"
              // boxShadow="lg"
            >
              <Image
                src={onboardingFlowSecondstep}
                alt="Text Message Marketing Preview"
                width="100%"
              />
            </Box>

            <Text
              fontSize={{base:"0.875rem", md:"15px"}}
              fontWeight="500"
              textAlign="center"
              mb={12}
              color={Colors.posTextInfo}
              maxW="638px"
            >
              Generate repeat customers and drive sales with our powerful Text
              Message marketing.
            </Text>

            {/* Features Grid */}
            <SimpleGrid
              columns={{ base: 1, md: 2 }}
              spacing={8}
              w="100%"
              maxW="638px"
            >
              {/* Feature 1 */}
              <Box maxWidth="19.5625rem">
                <Text
                  fontWeight="500"
                  color={Colors.posTextInfo}
                  mb={2}
                  fontSize="15px"
                >
                  Send Holiday Greetings
                </Text>
                <Text
                  color={Colors.taxCreateExemptEbt}
                  fontWeight="500"
                  fontSize="12px"
                >
                  Send holiday greetings or any generic messages to your
                  existing customers.
                </Text>
              </Box>

              {/* Feature 2 */}
              <Box maxWidth="19.5625rem">
                <Text
                  fontWeight="500"
                  color={Colors.posTextInfo}
                  mb={2}
                  fontSize="15px"
                >
                  Share flyer links via messages
                </Text>
                <Text
                  color={Colors.taxCreateExemptEbt}
                  fontWeight="500"
                  fontSize="12px"
                >
                  Create a flyer in canva and make it public. You can send the
                  public flyer link via SMS to your customers.
                </Text>
              </Box>

              {/* Feature 3 */}
              <Box maxWidth="19.5625rem">
                <Text
                  fontWeight="500"
                  color={Colors.posTextInfo}
                  mb={2}
                  fontSize="15px"
                >
                  Send Coupons for more Revenue
                </Text>
                <Text
                  color={Colors.taxCreateExemptEbt}
                  fontWeight="500"
                  fontSize="12px"
                >
                  Send targeted coupons to your customers. You can send it to a
                  custom audience. For example, customers who have not shopped
                  in last 60 days.
                </Text>
              </Box>

              {/* Feature 4 */}
              <Box maxWidth="19.5625rem">
                <Text
                  fontWeight="500"
                  color={Colors.posTextInfo}
                  mb={2}
                  fontSize="15px"
                >
                  Track SMS Campaigns
                </Text>
                <Text
                  color={Colors.taxCreateExemptEbt}
                  fontWeight="500"
                  fontSize="12px"
                >
                  You can track all metrics for your campaigns. If you have sent
                  coupons then you check how many have been redeemed.
                </Text>
              </Box>
            </SimpleGrid>

            {/* Navigation Buttons */}
            <Flex mt={12} w="100%" justify="space-between" maxW="638px">
              <Button
                variant="marketingOutline"
                colorScheme="blue"
                maxWidth="19.5625rem"
                width={!isScreenSize480 ? "19.5625rem" : "10rem"}
                // leftIcon={<ChevronLeftIcon />}
                onClick={() => {
                  // setSecondStep(false);
                  // setFirstStep(true);
                  window.open("https://octopos.com/", "_blank");
                }}
              >
                Learn More
              </Button>
              <PosFormButton
                buttonsubmit={"Next"}
                width={!isScreenSize480 ? "19.5625rem" : "10rem"}
                onClick={() => {
                  setSecondStep(false);
                  setFinalStep(true);
                  getCountryStates();
                }}
              />
            </Flex>
          </Flex>
        </Box>
      )}
      {finalStep && (
        <Box>
          <Box
            mb={0}
            textAlign={"left"}
            display="flex"
            alignItems="flex-start"
            flexDirection="row"
            gap={2}
          >
            <ChevronLeftIcon
              cursor="pointer"
              sx={{
                color: Colors.posTextInfo,
                fontSize: "1.50rem",
                width: "2rem",
                height: "2rem",
              }}
              onClick={() => {
                setFinalStep(false);
                setSecondStep(true);
                formik.resetForm();
              }}
            />
            <Flex flexDirection="column">
              <Heading
                fontSize={{base:"1rem", md:"1.50rem"}}
                fontStyle={"normal"}
                fontWeight={"600"}
                lineHeight={"normal"}
                letterSpacing={"-0.02rem"}
                color={Colors.posTextInfo}
              >
                Set Up Text Message Marketing
              </Heading>
              <Text
                fontSize={{base:"0.75rem", md:"0.94rem"}}
                fontStyle={"normal"}
                fontWeight={"500"}
                lineHeight={"normal"}
                letterSpacing={"-0.01rem"}
                color={Colors.taxCreateExemptEbt}
              >
                In order to send text messages you need to be registered with
                Campaign Registry of Mobile Carrier. Please fill out the form
                below to get approval from the registry.
              </Text>
            </Flex>
          </Box>
          <Divider
            pt={{ base: "2rem", md: "2rem" }}
            h={"0.8px"}
            color={Colors.dividerColor}
          />
          <Box mt={4} bg={Colors.posPageDataBackground}>
            {/* Register My Brand Accordion Header */}
            <Flex
              justify="space-between"
              align="center"
              p={4}
              borderRadius="md"
              bg={Colors.onBoardBackgroundHeader}
            >
              <Flex align="center" bg={Colors.onBoardBackgroundHeader}>
                <Box
                  w="16px"
                  h="16px"
                  borderRadius="full"
                  border="2px solid"
                  borderColor="#5881FEF5"
                  mr={3}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  {/* Your Radio Component Goes Here */}
                </Box>
                <Text fontWeight="500" color={Colors.posTextInfo}>
                  Register My Brand
                </Text>
              </Flex>
            </Flex>
            <Divider h={"0.8px"} color={Colors.dividerColor} />

            {/* Basic Information Section */}
            <Box
              mb={8}
              p={4}
              display="flex"
              flexDirection={{ base: "column", md: "row" }}
              width="100%"
            >
              <Box mb={4} width={{ base: "100%", md: "30%" }}>
                <Heading
                  as="h3"
                  size="xs"
                  fontWeight="500"
                  fontSize="1.125rem"
                  lineHeight="1.40625rem"
                  letterSpacing="-0.016875rem"
                  color={Colors.posTextInfo}
                >
                  Basic Information
                </Heading>
                <Text
                  color="rgba(1, 0, 72, 0.6)"
                  pt="2"
                  fontSize="sm"
                  maxW={{ base: "100%", md: "20.625rem" }}
                >
                  Provide basic details on your what your business is and where
                  to find it
                </Text>
              </Box>

              <SimpleGrid
                columns={{ base: 1, md: 2 }}
                spacing={6}
                width={{ base: "100%", md: "70%" }}
              >
                {/* Legal Company Name */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Legal Company Name
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="legalCompanyName"
                    placeholder="Enter Legal Company Name"
                    posInput={true}
                    inputType={"text"}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.legalCompanyName || ""}
                    handleBlur={(e) => {
                      if (formik.values.legalCompanyName) {
                        formik.setFieldValue(
                          "legalCompanyName",
                          formik.values.legalCompanyName.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    // onKeyDown={handleKeyDown}
                    inputError={
                      formik.touched.legalCompanyName &&
                      formik.errors.legalCompanyName
                    }
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.legalCompanyName &&
                    formik.errors.legalCompanyName
                      ? formik.errors.legalCompanyName
                      : null}
                  </Text>
                </Box>

                {/* DBA or Brand Name */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    DBA or Brand Name
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="dbaOrBrandName"
                    placeholder="Enter DBA or Brand Name"
                    width="100%"
                    posInput={true}
                    inputType={"text"}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.dbaOrBrandName || ""}
                    handleBlur={(e) => {
                      if (formik.values.dbaOrBrandName) {
                        formik.setFieldValue(
                          "dbaOrBrandName",
                          formik.values.dbaOrBrandName.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    // onKeyDown={handleKeyDown}
                    inputError={
                      formik.touched.dbaOrBrandName &&
                      formik.errors.dbaOrBrandName
                    }
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.dbaOrBrandName &&
                    formik.errors.dbaOrBrandName
                      ? formik.errors.dbaOrBrandName
                      : null}
                  </Text>
                </Box>

                {/* Phone */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Phone
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="phone"
                    width="100%"
                    posNumberInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.phone || ""}
                    handleBlur={(e) => {
                      if (formik.values.phone) {
                        formik.setFieldValue(
                          "phone",
                          formik.values.phone.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={formik.touched.phone && formik.errors.phone}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.phone && formik.errors.phone
                      ? formik.errors.phone
                      : null}
                  </Text>
                </Box>

                {/* Email Address */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Email Address
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="email"
                    placeholder="Enter email address"
                    width="100%"
                    posInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.email || ""}
                    handleBlur={(e) => {
                      if (formik.values.email) {
                        formik.setFieldValue(
                          "email",
                          formik.values.email.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={formik.touched.email && formik.errors.email}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.email && formik.errors.email
                      ? formik.errors.email
                      : null}
                  </Text>
                </Box>

                {/* Address */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Address
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="address"
                    width="100%"
                    posInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.address || ""}
                    handleBlur={(e) => {
                      if (formik.values.address) {
                        formik.setFieldValue(
                          "address",
                          formik.values.address.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={formik.touched.address && formik.errors.address}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.address && formik.errors.address
                      ? formik.errors.address
                      : null}
                  </Text>
                </Box>

                {/* City */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    City
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="city"
                    placeholder="Enter City"
                    width="100%"
                    posInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.city || ""}
                    handleBlur={(e) => {
                      if (formik.values.city) {
                        formik.setFieldValue("city", formik.values.city.trim());
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={formik.touched.city && formik.errors.city}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.city && formik.errors.city
                      ? formik.errors.city
                      : null}
                  </Text>
                </Box>

                {/* Country */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Country
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosCountryStateDropDown
                    options={countries}
                    value={formik.values.selectedCountry}
                    countriesSelect={true}
                    onChange={(e) => {
                      if (
                        undefined != e.target.value &&
                        null != e.target.value &&
                        "" != e.target.value
                      ) {
                        handleSelectedCountry(e.target.value);
                        formik.setFieldValue("selectedCountry", e.target.value);
                      }
                    }}
                    onBlur={(e) => {
                      formik.setFieldTouched("selectedCountry", true);
                      // if (!e.target.value) {
                      //   setCountryError(Constants.CUSTOMER_PLEASE_SELECT_A_COUNTRY);
                      // } else {
                      //   setCountryError("");
                      // }
                    }}
                    optionLabel="label"
                    placeholder="--Select Country--"
                    width={"100%"}
                    maxWidth={"42rem"}
                    height={"2.5rem"}
                    resetFilterOnHide={true}
                    className="w-full md:w-20rem"
                    lableAvailable={true}
                    disabled={false}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.selectedCountry &&
                    formik.errors.selectedCountry ? (
                      <span>{formik.errors.selectedCountry}</span>
                    ) : null}
                  </Text>

                  {/* Your Dropdown Component Goes Here */}
                </Box>

                {/* State/Province */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    State/Province
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  {states.length === 0 ? (
                    <Select
                      id="state"
                      value={formik.values.selectedState || "N.A"}
                      sx={{
                        color: "gray",
                        fontSize: "0.94rem !important",
                        fontWeight: 300,
                        letterSpacing: "-0.01rem !important",
                        backgroundColor: "#5881fe0d",
                        borderRadius: "0.625rem",
                        height: "2.5rem",
                        border: "1px solid #b7b7b71f",
                        "&[disabled]": {
                          backgroundColor: "#5881fe0d !important",
                          opacity: 1,
                        },
                      }}
                      // onChange={(e) => {
                      //   handleSelectedState(e.target.value);
                      //   formikCustomer.setFieldValue("selectedState", e.target.value);
                      // }}
                      isDisabled
                      placeholder={
                        states.length > 0 ? "N.A" : "--Select State--"
                      }
                    >
                      <option value="N.A">N.A</option>
                    </Select>
                  ) : (
                    <PosCountryStateDropDown
                      options={states}
                      value={selectedState}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        if (
                          undefined != e.value &&
                          null != e.value &&
                          "" != e.value
                        ) {
                          handleSelectedState(selectedValue);
                          formik.setFieldValue("selectedState", selectedValue);
                          formik.setFieldTouched("selectedState", true);
                          if (!selectedValue) {
                            formik.setFieldError(
                              "selectedState",
                              Constants.CUSTOMER_PLEASE_SELECT_A_STATE
                            );
                          } else {
                            formik.setFieldError("selectedState", "");
                          }
                        }
                      }}
                      onBlur={() => {
                        formik.setFieldTouched("selectedState", true);
                      }}
                      optionLabel="label"
                      placeholder="--Select State--"
                      width={"100%"}
                      maxWidth={"42rem"}
                      height={"2.5rem"}
                      resetFilterOnHide={true}
                      className="w-full md:w-20rem"
                      lableAvailable={true}
                      disabled={false}
                    />
                  )}
                  {states.length > 0 && (
                    <Text color={Colors.errorColor}>
                      {formik.touched.selectedState &&
                      formik.errors.selectedState ? (
                        <span>{formik.errors.selectedState}</span>
                      ) : null}
                    </Text>
                  )}
                  {/* Your Dropdown Component Goes Here */}
                </Box>

                {/* Zip Code */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Zip Code
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="zipcode"
                    width="100%"
                    posNumberInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.zipcode || ""}
                    handleBlur={(e) => {
                      if (formik.values.zipcode) {
                        formik.setFieldValue(
                          "zipcode",
                          formik.values.zipcode.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={formik.touched.zipcode && formik.errors.zipcode}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.zipcode && formik.errors.zipcode
                      ? formik.errors.zipcode
                      : null}
                  </Text>
                </Box>
              </SimpleGrid>
            </Box>

            {/* Additional Information Section */}
            <Box
              p={4}
              display="flex"
              flexDirection={{ base: "column", md: "row" }}
              width="100%"
            >
              <Box mb={4} width={{ base: "100%", md: "30%" }}>
                <Heading
                  as="h3"
                  size="xs"
                  fontWeight="500"
                  fontSize="1.125rem"
                  lineHeight="1.40625rem"
                  letterSpacing="-0.016875rem"
                  color={Colors.posTextInfo}
                >
                  Additional Information
                </Heading>
                <Text
                  color="rgba(1, 0, 72, 0.6)"
                  pt="2"
                  fontSize="sm"
                  maxW={{ base: "100%", md: "20.625rem" }}
                >
                  Provide further details about your business
                </Text>
              </Box>

              <SimpleGrid
                columns={{ base: 1, md: 2 }}
                spacing={6}
                width={{ base: "100%", md: "70%" }}
              >
                {/* What type of legal form is the org */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    What type of legal form is the org?
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="legalForm"
                    width="100%"
                    posInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.legalForm || ""}
                    handleBlur={(e) => {
                      if (formik.values.legalForm) {
                        formik.setFieldValue(
                          "legalForm",
                          formik.values.legalForm.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={
                      formik.touched.legalForm && formik.errors.legalForm
                    }
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.legalForm && formik.errors.legalForm
                      ? formik.errors.legalForm
                      : null}
                  </Text>
                </Box>

                {/* Tax Number/ID/EIN */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Tax Number/ID/EIN
                    <Box as="span" color="red.500">
                      *
                    </Box>
                  </Text>
                  <PosInput
                    id="taxNumber"
                    width="100%"
                    posInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.taxNumber || ""}
                    handleBlur={(e) => {
                      if (formik.values.taxNumber) {
                        formik.setFieldValue(
                          "taxNumber",
                          formik.values.taxNumber.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={
                      formik.touched.taxNumber && formik.errors.taxNumber
                    }
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.taxNumber && formik.errors.taxNumber
                      ? formik.errors.taxNumber
                      : null}
                  </Text>
                </Box>

                {/* Website */}
                <Box>
                  <Text
                    mb={2}
                    fontWeight="400"
                    color={Colors.onBoardBackgroundLableText}
                  >
                    Website
                  </Text>
                  <PosInput
                    id="website"
                    width="100%"
                    posInput={true}
                    handleInputChange={formik.handleChange}
                    inputValue={formik.values.website || ""}
                    handleBlur={(e) => {
                      if (formik.values.website) {
                        formik.setFieldValue(
                          "website",
                          formik.values.website.trim()
                        );
                      }
                      formik.handleBlur(e);
                    }}
                    inputError={formik.touched.website && formik.errors.website}
                  />
                  <Text color={Colors.errorColor}>
                    {formik.touched.website && formik.errors.website
                      ? formik.errors.website
                      : null}
                  </Text>
                </Box>
              </SimpleGrid>
            </Box>
            {/* Submit Button */}
            <Flex justify="flex-end" p={4}>
              <PosFormButton
                buttonsubmit={"Submit"}
                width={"11.44rem"}
                onClick={async () => {
                  await formik.setTouched({
                    legalCompanyName: true,
                    dbaOrBrandName: true,
                    phone: true,
                    email: true,
                    address: true,
                    city: true,
                    selectedCountry: true,
                    selectedState: true,
                    zipcode: true,
                    legalForm: true,
                    taxNumber: true,
                    website: true,
                  });
                  const errors = await formik.validateForm();
                  if (Object.keys(errors).length === 0) {
                    onSubmitClick();
                  }
                }}
              />
            </Flex>
          </Box>
        </Box>
      )}
      {statusPendingList && (
        <Box>
          <Box
            mb={0}
            textAlign={"left"}
            direction="row"
            display="flex"
            alignItems="flex-start"
            gap={2}
          >
            <ChevronLeftIcon
              cursor="pointer"
              sx={{
                color: Colors.posTextInfo,
                fontSize: "1.50rem", // Match heading font size
                width: "2rem", // Ensure width matches
                height: "2rem", // Ensure height matches
              }}
              onClick={() => {
                navigate(Constants.DASHBOARD_PATH);
              }}
            />
            <Flex direction="column" gap={2}>
              <Heading
                fontSize={{base:"1rem", md:"1.50rem"}}
                fontStyle={"normal"}
                fontWeight={"600"}
                lineHeight={"normal"}
                letterSpacing={"-0.02rem"}
                color={Colors.posTextInfo}
              >
                Set Up Text Message Marketing
              </Heading>
              <Text
                fontSize={{base:"0.75rem", md:"0.94rem"}}
                fontStyle={"normal"}
                fontWeight={"500"}
                lineHeight={"normal"}
                letterSpacing={"-0.01rem"}
                color={Colors.taxCreateExemptEbt}
              >
                In order to send text messages you need to be registered with
                Campaign Registry of Mobile Carrier. Please fill out the form
                below to get approval from the registry.
              </Text>
            </Flex>
          </Box>

          <Divider
            pt={{ base: "2rem", md: "2rem" }}
            // pb={{ base: "2rem", md: "2rem" }}
            h={"0.8px"}
            color={Colors.dividerColor}
          />

          <Box
            mt={{ base: "2rem", md: "2rem" }}
            direction="row"
            display="flex"
            alignItems="flex-start"
            gap={2}
          >
            <Image src={processPendingIcon} alt="Pending Approval" />
            {/* <ChevronLeftIcon
            sx={{ 
              color: Colors.posTextInfo,
            }} 
            />*/}
            <Flex direction={"column"} gap={2} w={"100%"}>
              <Text
                fontSize={"1.125rem"}
                fontWeight={"500"}
                lineHeight={"normal"}
                letterSpacing={"-0.02rem"}
                color={Colors.posTextInfo}
              >
                Pending Approval
              </Text>
              <Text
                fontSize={"0.94rem"}
                fontWeight={"300"}
                lineHeight={"normal"}
                letterSpacing={"-0.01rem"}
                color={Colors.taxCreateExemptEbt}
              >
                Thank you We're currently reviewing your information to activate
                your number for Text Message Marketing. This process typically
                takes up to 2 weeks.
              </Text>
              <Text
                fontSize={"0.94rem"}
                fontWeight={"300"}
                lineHeight={"normal"}
                letterSpacing={"-0.01rem"}
                color={Colors.taxCreateExemptEbt}
              >
                We'll notify you as soon as your phone number is activated.
              </Text>
              <Box
                width="100%"
                height="5px"
                bg="#D9D9D9"
                borderRadius={"0.3125rem"}
              >
                <Box
                  width="70%"
                  height="100%"
                  borderRadius={"0.3125rem"}
                  bg={"#B582F4"}
                />
              </Box>
              <Box
                mt={{ base: 4, md: 8 }}
                p={4}
                bg={Colors.posPageDataBackground}
                borderRadius={"0.5rem"}
              >
                {pendingStatusList.map((item) => (
                  <Flex key={item.id} gap={2} w="100%" alignItems={"center"} flexDirection={{base: "column", md: "row"}}>
                    <Flex direction="row" align="flex-start" justify="flex-start" gap={2} width={{base: "100%", md: "50%"}} >
                    <CheckCircleIcon
                      // width={{base: "100%", md: "10%"}}
                      sx={{
                        color: Colors.checkCircleIconColor,
                      }}
                    />
                    <Text
                      // width={{base: "100%", md: "45%"}}
                      key={item.id}
                      color={Colors.posTextInfo}
                    >
                      Register My Brand
                    </Text>
                    </Flex>
                    <Text
                      width={{base: "100%", md: "15%"}}
                      key={item.id}
                      fontSize={"0.94rem"}
                      lineHeight={"100%"}
                      color={Colors.taxCreateExemptEbt}
                      fontWeight={"300"}
                    >
                      {item.business_name ? item.business_name : item.name}
                    </Text>
                    {/* <Text
                      width={{base: "100%", md: "15%"}}
                      key={item.id}
                      fontSize={"0.94rem"}
                      lineHeight={"100%"}
                      color={Colors.taxCreateExemptEbt}
                      fontWeight={"300"}
                    >
                      {item.twilio_phone_number}
                    </Text> */}
                    <Text
                      width={{base: "100%", md: "20%"}}
                      key={item.id}
                      fontSize={"0.94rem"}
                      lineHeight={"100%"}
                      color={Colors.taxCreateExemptEbt}
                      fontWeight={"300"}
                    >
                      {item.email}
                    </Text>
                    {/* <Text width={"15%"} key={item.id} color={Colors.posTextInfo}>{item.status}</Text> */}
                    <Text
                      width={{base: "100%", md: "15%"}}
                      key={item.id}
                      color="#FC951A"
                      fontSize="0.875rem"
                      fontWeight="500"
                      bg="#FFF8F0"
                      borderRadius="1rem"
                      display="inline-flex"
                      alignItems="center"
                      justifyContent="center"
                      textTransform="capitalize"
                    >
                      Pending approval
                    </Text>
                  </Flex>
                ))}
              </Box>
              <Divider color={Colors.dividerColor} />
              <Flex
                direction={"column"}
                gap={2}
                alignItems={"flex-end"}
                mt={{base: "2rem", md: "6.0625rem"}}
              >
                <Text
                  fontSize={"0.75rem"}
                  fontWeight={"400"}
                  lineHeight={"100%"}
                  letterSpacing={"-1.5%"}
                  color={Colors.taxCreateExemptEbt}
                >
                  To update your business information please
                </Text>
                <Button
                  variant={"marketingOutline"}
                  fontSize={"0.75rem"}
                  fontWeight={"500"}
                  lineHeight={"100%"}
                  letterSpacing={"-1.5%"}
                  bg={"transparent"}
                  maxWidth={"8rem"}
                  leftIcon={<Image src={contactUsIcon} alt="Contact Us" />}
                  onClick={() => {
                    window.open("https://octopos.com/", "_blank");
                  }}
                >
                  Contact Us
                </Button>
              </Flex>
            </Flex>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MarketingOnbordingForm;
